import {selectFilters} from './PageNews.js';


export function generatePseudoSelect(_items) {
	_items.each(function (index, el) {
		let $currPseudoSelect = $(el);

		$currPseudoSelect.append('<div class="pseudo-select__dropdown js-pseudo-select-drop"></div>');

		$currPseudoSelect.find('option').each(function (optionIndex, optionEl) {
			let $currOption = $(optionEl);
			let _selectedClass = $currOption.is(':selected') ? '_selected' : '';

			$currPseudoSelect
				.find('.js-pseudo-select-drop')
				.append(`
				<div>
					<span class="js-pseudo-select-item ${_selectedClass}" data-index="${$currOption.data('index')}">${$currOption.html()}</span>
				</div>
			`);
		});
	});
}

App.H.on('change', '.js-pseudo-select-select', function () {
	let _currValue = $(this).find(':selected').html();
	let $currPseudoSelect = $(this).closest('.js-pseudo-select');
	let currSelectIndex = $currPseudoSelect.find('option:selected').data('index');
	let $currSelect = $currPseudoSelect.find('select');

	$currPseudoSelect.find('.js-pseudo-select-btn span').html(_currValue);

	if ($currPseudoSelect.data('link')) {
		window.location.href = $currPseudoSelect.find(`option[data-index=${currSelectIndex}]`).val();
	} else {
		selectFilters($currSelect);
	}
});


/* Открываем псевдоселект */
App.H.on('click', '.js-pseudo-select-btn', function (e) {
	if (!App.mobile) {
		$(this).toggleClass('_open').siblings('.js-pseudo-select-drop').toggleClass('_open');
	}

	e.preventDefault();
});

/* Выбор пункта в псевдоселекте */
App.H.on('click', '.js-pseudo-select-item', function () {
	let $currPseudoItem = $(this);
	let currSelectIndex = $currPseudoItem.data('index');
	let $currSelect = $currPseudoItem.closest('.js-pseudo-select');

	if (!$currPseudoItem.hasClass('_selected')) {
		$currSelect.find('option').prop('selected', false).removeAttr('selected');
		$currSelect.find(`option[data-index=${currSelectIndex}]`).prop('selected', true).attr('selected', 'selected');
		$currSelect.find('.js-pseudo-select-item').removeClass('_selected');
		$currPseudoItem.addClass('_selected');
		$currSelect.find('.js-pseudo-select-select').trigger('change');

		if ($currSelect.data('link')) {
			window.location.href = $currSelect.find(`option[data-index=${currSelectIndex}]`).val();
		} else {
			$currSelect.find('.js-pseudo-select-btn span').html($currPseudoItem.html());
			$currSelect.find('.js-pseudo-select-btn._open').trigger('click');
		}
	}
});

/* Если клик не по псевдоселект, то закрываем его */
App.D.on('mouseup', function (e) {
	if (!$('.js-pseudo-select-drop').is(e.target) && $('.js-pseudo-select-drop').has(e.target).length === 0) {
		$('.js-pseudo-select-btn._open').trigger('click');
	}
});

//generatePseudoSelect();
generatePseudoSelect($('.js-pseudo-select'));


// WEBPACK FOOTER //
// ./_src/js/modules/UI.js